import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { Common, PopUpBox } from '../../../components';
import { styles, options, numberWithNoCommas } from '../../../utils/common';

import { actionMoneyForm2, actionSubmitForm21 } from '../../../store/application/actions';
import { actionTracking } from '../../../store/common/actions';
import DropdownIndicator from '../../../components/Common/DropdownIndicator';

function StepForm2({ sessionId, formData, onCompleted}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        setValue,
        register,
        handleSubmit,
        setError,
        formState: { errors, isSubmitting },
    } = useForm();
    const [mpf, setMpf] = useState(null);
    const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);


    const onSubmit = async (data) => {
        const obj = {
            business_type: data?.business_type,
            job_type: data?.job_type,
            position: data?.position,
            employment_type: data?.employment_type,
            receipt_way: data?.receipt_way,
            monthly_income: numberWithNoCommas(data?.monthly_income),
            payroll_method: data?.payroll_method,
            mpf: mpf,
            session_id: sessionId,
            phone_number: formData['form1']['phone_number']
        };
        console.log(obj);
        const response = await dispatch(actionMoneyForm2(obj));
        if (response?.sts_code === 0) {
            onCompleted({ status: true, data: { form2: obj } })
        }
    };

    const beforeunload = (e) => {
        // const event = e || window.event;
        // if (event) {
        //     event.returnValue = 'Sure?';
        // }
        // return 'Sure?';
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('beforeunload', beforeunload);

        return () => {
            window.removeEventListener('beforeunload', beforeunload);
        };
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isVisibleInvalidToken && <PopUpBox.InvalidToken />}
            <Common.Loading isVisible={isSubmitting} />
            <div className="bg-white lg:px-10">
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">工作類型</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('job_type', { required: true })}
                                onChange={(e) => {
                                    setValue('job_type', e.value);
                                    setError('job_type', null);
                                }}
                                options={options.job_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.job_type && errors?.job_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">業務類型</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('business_type', { required: true })}
                                onChange={(e) => {
                                    setValue('business_type', e.value);
                                    setError('business_type', null);
                                }}
                                options={options.business_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.business_type && errors?.business_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">職位</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('position', { required: true })}
                                onChange={(e) => {
                                    setValue('position', e.value);
                                    setError('position', null);
                                }}
                                options={options.position}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.position && errors?.position?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray  font-bold mb-2">受聘形式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('employment_type', { required: true })}
                                onChange={(e) => {
                                    setValue('employment_type', e.value);
                                    setError('employment_type', null);
                                }}
                                options={options.employment_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.employment_type && errors?.employment_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray  font-bold mb-2">出糧方式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('receipt_way', { required: true })}
                                onChange={(e) => {
                                    setValue('receipt_way', e.value);
                                    setError('receipt_way', null);
                                }}
                                options={options.receipt_way}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.receipt_way && errors?.receipt_way?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray  font-bold mb-2">月收入</p>
                        <Common.InputMoney zeroAllow={true} placeholder=" " register={register} title="monthly_income" setError={setError} errors={errors} />
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray  font-bold mb-2">支薪方式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('payroll_method', { required: true })}
                                onChange={(e) => {
                                    setValue('payroll_method', e.value);
                                    setError('payroll_method', null);
                                }}
                                options={options.payroll_method}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.payroll_method && errors?.payroll_method?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray  font-bold mb-2">MPF強積金</p>
                        <div className="relative">
                            <div className='flex space-x-10 max-md:justify-center'>
                                {options.mpf.map(item => {
                                    return (
                                        <div {...register('mpf', { required: true })} key={item.value} onClick={() => {
                                            setValue('mpf', item.value);
                                            setMpf(item.value)
                                            setError('mpf', null);
                                        }} className={`w-24 h-12 cursor-pointer border text-gray1 border-primary rounded-md flex justify-center items-center ${mpf === item.value ? 'bg-primary text-white' : 'bg-white'}`}>
                                            {item.label}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {errors?.mpf && errors?.mpf?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="flex justify-center mt-9 mb-4">
                    <button disabled={isSubmitting} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'} button2`}>
                        第三步
                    </button>
                </div>
            </div>
        </form>
    );
}

export default StepForm2;
